import { z } from 'zod'
import { SystemMessages } from 'utils/enums/system-message.enum'

export const TeenagerRecordAuditSchema = z.object({
  dataInicial: z.string().min(1, SystemMessages.MESSAGE_002),
  dataFinal: z.string().min(1, SystemMessages.MESSAGE_002),
  nomeAdolescente: z.string().min(1, SystemMessages.MESSAGE_002),
  acao: z.string().nullish(),
  funcionalidade: z.string().nullish(),
  usuario: z.string().nullish(),
})

export type TeenagerRecordAuditType = z.infer<typeof TeenagerRecordAuditSchema>

export const TeenagerRecordAuditDefaultValues: TeenagerRecordAuditType = {
  dataInicial: '',
  dataFinal: '',
  nomeAdolescente: '',
  acao: null,
  funcionalidade: null,
  usuario: null,
}
